@if (item) {
  <div class="basket-item-container">
    <div style="display: flex;  width: 100%; align-items: center;">
      @if (!tenant.SuppressProductImages && !isMobile && showImages) {
        <div class="basket-item-image-container deal-item-image-container">
          <img class="basket-item-image" [draggable]="false" [src]="item.imageUrl">
        </div>
      }
  
      <div class="basket-item-details">
        <div class="basket-item-details-row-group">
          <h4>{{ item.name }}</h4>
  
          @if (item.isInVoucher) {
            <button mat-flat-button class="basket-item-voucher-tag">Voucher</button>
          }
        </div>
        @if (basketIsModifiable) {
          <button mat-flat-button class="basket-item-quantity-remove-item" (click)="removeDealItem()">
            <mat-icon>close</mat-icon>
            Remove
          </button>
        }
      </div>
  
      <span class="basket-item-price">£{{ item.price | StringToMoneyFilter }}</span>
    </div>

    @if (item.hasIssues) {
      <p class="red-alert-text">Sorry there's a problem with this deal.</p>
    } @else {
      <div class="deal-expansion-toggle">
        <mat-icon (click)="toggleDealExpansion()">
          {{ item.expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>
    }
  
    @if (item.expanded || item.hasIssues) {
      <div class="deal-contents-container">
        <p>Contains</p>

        @for (item of item.items; track $index) {
          <div style="display: flex; align-items: center;">
            @if (!tenant.SuppressProductImages && !isMobile) {
              <div class="basket-item-image-container deal-item-image-container">
                <img class="basket-item-image" draggable="false" id="{{ 'dealItem-img-' + $index }}" [src]="item.imageUrl">
              </div>
            }
        
            <div class="basket-item-details" [ngClass]="{'no-max-width': tenant.SuppressProductImages}">
              <div class="flex-column" style="line-height: initial;">
                <span>{{ item.name }}</span>

                @for (issue of item.issues; track $index) {
                  <span class="basket-item-error">{{ issue.Narrative }}</span>
                }
              </div>

              @if (item.modifiers) {
                  <div class="basket-item-addons-group">
                    @for (mod of item.modifiers.addons; track $index) {
                      <div class="basket-item-addons-chip add-chip">
                        <mat-icon>add</mat-icon>
                        <span>{{ mod.quantity }}</span>
                        <span>{{ mod.name }}</span>
                      </div>
                    }
          
                    @for (mod of item.modifiers.removes; track $index) {
                      <div class="basket-item-addons-chip remove-chip">
                        <mat-icon>remove</mat-icon>
                        <span>{{ mod.name }}</span>
                      </div>
                    }
                  </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
